import { MAP_LAYER_FACTS, MapRastersFact } from '@/api/rest/resources/types/fact';
import { useIndicatorProduct } from '@/hooks/useIndicatorProduct';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';
import { isNullish } from '@/utils/booleans';

import { LAYER_OPTIONS, LayerProps, MAP_ORIGIN } from '../constants';

export const useAddFactMapLayers = (layers: LayerProps[], facts: MAP_LAYER_FACTS[]): LayerProps[] => {
  const purchasedIndicatorProducts =
    useIndicatorProduct({
      purchased: true,
      visible_for_customer: true,
    }).data ?? [];
  const mapFactsInLayers = layers.map((layer) => layer.value);

  const factsWithPurchasedSubscription = facts.filter((fact) =>
    purchasedIndicatorProducts.some((ip) => ip.indicator_names.includes(fact)),
  );

  const factsLayers = LAYER_OPTIONS.filter((layer) => facts.includes(layer.value));

  const factsWithFactOrigin = factsLayers
    .filter((layer) => layer.origin === MAP_ORIGIN.fact)
    .map((layer) => layer.value);

  const plotFacts = usePlotFacts<MapRastersFact>(factsWithFactOrigin);

  const newLayers = factsLayers.filter((layer) => {
    const factName = layer.value;
    const isFactIndicatorProductSubscribed = factsWithPurchasedSubscription.includes(factName);
    const isFactAlreadyInLayers = mapFactsInLayers.includes(factName);

    if (!isFactIndicatorProductSubscribed || isFactAlreadyInLayers) {
      return false;
    }

    if (layer.origin !== MAP_ORIGIN.fact) {
      return true;
    }

    return !isNullish(getFactFromFactArray<MapRastersFact>(plotFacts, factName)?.value);
  });

  return [...layers, ...newLayers];
};
